import code from "./code";
import color from "./color";
import combine from "./combine";
import combineCoord from "./combineCoord";
import coord from "./coord";
import custom_functions from "./custom_functions";
import src from "./src";
const functions = [...src, ...color, ...coord, ...combineCoord, ...combine];
export const glsl_functions = [...functions, ...code, ...custom_functions];
const setFunctionHooks = [];
export function onSetFunction(hook) {
    if (!setFunctionHooks.includes(hook))
        setFunctionHooks.push(hook);
}
export function toArray(input, length, defaults = []) {
    if (typeof input === "string")
        return input;
    if (typeof input === "number")
        return Array.from({ length }, () => input);
    if (Array.isArray(input))
        return Array.from({ length }, (_, i) => input[i] ?? defaults[i] ?? 0);
    return input;
}
export function setFunction(fn) {
    // validate fn, check if name, type and glsl exist
    if (!fn.name || !fn.type || (fn.type !== "code" && !("glsl" in fn))) {
        console.error("Invalid GLSLFunction", fn);
        return;
    }
    const index = glsl_functions.findIndex(({ name }) => name === fn.name);
    if (index !== -1) {
        console.warn(`Function ${fn.name} already exists`);
        return;
    }
    glsl_functions.push(fn);
    setFunctionHooks.forEach(hook => hook(fn));
}
